<template>
  <div>
    <div class="home-header">
      <div class="header-search">
        <van-field @click-input="checkInput" v-model="value1" placeholder="请输入产品名称">
          <template #right-icon>
            <svg-icon icon-class="home_search"></svg-icon>
          </template>
        </van-field>
        <div class="header-search-img" @click.prevent="goinfo">
          <!-- <svg-icon icon-class="home_top"></svg-icon> -->
          <van-badge :content="messageCount" max="99">
            <svg-icon icon-class="home_info"></svg-icon>
            <!-- <div class="child" /> -->
          </van-badge>
        </div>
      </div>
      <div class="home-swipe">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <img class="swipe-img" src="../../assets/img/banner.png" alt @click="routerImg" />
        </van-swipe>
      </div>
      <!-- 捷报轮播 -->
<!--      <div class="messageBox" @click="leaderboard">-->
      <div class="messageBox">
        <van-notice-bar scrollable :text="newsList" @click="routerPath">
          <template #left-icon>
            <div class="box-left">
              <img src="@/assets/publicImg/broadcast.png" alt />
              <div>捷报</div>
            </div>
          </template>
        </van-notice-bar>
      </div>
      <applications></applications>
<!--      <product-library></product-library>-->
      <hot-product></hot-product>
      <!-- 购买vip图暂时去掉 -->
      <!-- <div class="home-vip">
        <img @click="isPay" src="./img/hoem_vip.png" alt />
      </div>-->
    </div>
    <div class="home-product home-article">
      <div class="home-pro-title">
        <div class="pro-title-left">
          <svg-icon icon-class="home_pro_line"></svg-icon>
          <span>热门文章</span>
        </div>
        <div class="pro-title-right" @click.prevent="moreArticles">
          <span>更多</span>
          <svg-icon icon-class="home_pro_more"></svg-icon>
        </div>
      </div>
      <div class="home-article-nav">
        <ul>
          <li
            v-for="(item,index) in liList"
            :key="index"
            :class="isLink==index ? 'li-style li-check-style' : 'li-style'"
            @click="chooseLi(item,index)"
          >{{item.name}}</li>
        </ul>
        <ul class="home-nav2">
          <li
            v-for="(item,index) in liList2"
            :key="index"
            :class="isLink2==index ? 'li-style2 li-check-style2' : 'li-style2'"
            @click="chooseLi2(item,index)"
          >
            {{item.name}}
            <svg-icon v-if="isLink2==index" icon-class="home_line2"></svg-icon>
          </li>
        </ul>
      </div>
      <!-- 置顶文章 -->
      <div v-if="level1=='1' && level2=='推荐' ">
        <div class="home-data-list" v-for="(item,index) in dataList " :key="'home0'+index">
          <div
            v-if="item.contentType=='ART'"
            class="home-list-sty"
            @click.prevent="goToDetails(item.artcId,item.coverLink)"
          >
            <!-- <div class="list-left">
            <img src="./img/home_article1.png" alt />
            </div>-->
            <div class="list-right list-top-right">
              <div class="list-r-tit">
                <!-- <img src="./img/home_name0.png" alt /> -->
                <svg-icon icon-class="home_name2"></svg-icon>
                <span>{{item.title}}</span>
              </div>
              <div class="list-r-foot">
                <span class="list-top-span">置顶</span>
                <span>阅读 {{item.viewCount || 0}} 次</span>
                <span>转发 {{item.fwdCount || 0}} 次</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="list-top-line"></div>
      <!-- 推荐文章列表 -->
      <div class="home-data-list" v-for="(item,index) in dataList1 " :key="'home1'+index">
        <!-- 文章 -->
        <div
          v-if="item.contentType=='ART'"
          class="home-list-sty"
          @click.prevent="goToDetails(item.artcId,item.coverLink)"
        >
          <div class="list-left">
            <img :src="item.coverLink" alt />
          </div>
          <div class="list-right">
            <div class="list-r-tit">
              <!-- <img src="./img/home_name0.png" alt /> -->
              <svg-icon icon-class="home_name2"></svg-icon>
              <span>{{item.title}}</span>
            </div>
            <div class="list-r-foot">
              <span>阅读 {{item.viewCount || 0}} 次</span>
              <span>转发 {{item.fwdCount || 0}} 次</span>
            </div>
          </div>
        </div>
        <!-- 图文 -->
        <div v-if="item.contentType=='PAW'">
          <div class="list-r-tit">
            <!-- <img src="./img/home_name1.png" alt /> -->
            <svg-icon icon-class="home_name1"></svg-icon>
            <span>{{item.artcSummary}}</span>
          </div>
          <div class="home-imgList-sty">
            <!-- 图片大于一张 并且不是四张 -->
            <div v-if="item!=4" class="home-isImg">
              <div
                v-for="(it,ind) in item.imgurl"
                :key="'inedex2'+ind"
                :class="item > 1 && item!=4 ? 'home-img-size home-img-size2':'home-img-size'"
              >
                <div>
                  <van-image
                    @click="sceneImg(item,$event)"
                    v-if="it"
                    width="100%"
                    height="100%"
                    :src="it"
                  />
                </div>
              </div>
            </div>
            <!-- 图片是四张 -->
            <div v-if="item==4" class="home-isImg">
              <div v-for="(itS,indS) in item.imgurl" :key="'index0'+indS" class="home-img-size4">
                <div>
                  <van-image
                    @click="sceneImg(item,$event)"
                    v-if="itS.img"
                    width="100%"
                    height="100%"
                    :src="itS.img"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="list-r-foot list-igm-foot">
            <span>阅读 {{item.viewCount || 0}} 次</span>
            <span>转发 {{item.fwdCount || 0}} 次</span>
          </div>
        </div>
        <!-- 视频 -->
        <div v-if="item.contentType=='VOD'">
          <div class="list-r-tit">
            <!-- <img src="./img/home_name2.png" alt /> -->
            <svg-icon icon-class="home_name3"></svg-icon>
            <span>{{item.vtitle}}</span>
          </div>
          <div class="home-imgList-sty">
            <div class="home-img-size">
              <div>
                <van-image
                  @click="goToVideo('inner',item.artcId)"
                  width="100%"
                  height="100%"
                  :src="item.faceImgUrl || item.imgUrl1"
                  style="object-fit: cover;"
                />
              </div>
            </div>
          </div>
          <div class="list-r-foot list-igm-foot">
            <span>阅读 {{item.viewCount || 0}} 次</span>
            <span>转发 {{item.fwdCount || 0}} 次</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 购买弹框 -->
    <!-- <van-popup @close="closePop" close-icon="close" v-model="show" closeable>
      <div>
        <img src="../../assets/img/tg.png" alt />
        <div @click.prevent="isPay" class="popup-buttom">goumai</div>
      </div>
    </van-popup>-->
    <!-- 获客指引弹框 -->
<!--    <guide></guide>-->
  </div>
</template>

<script>
import URL from "@/api/api";
import URLTB from "@/api/apiTB";
import { Toast } from "vant";
import { setSession, setLocal } from "@/utils/utils";
import Applications from './applications.vue';
// import guide from '../pop-up-guide/index.vue'
import HotProduct from './hotProduct.vue';
// import ProductLibrary from './productLibrary.vue';
export default {
  components: {
    Applications,
    // guide,
    HotProduct,
    // ProductLibrary
  },
  data() {
    return {
      messageCount: '',//消息条数
      newsList: '',
      productList: [],
      value1: '',
      isLink: '0',
      isLink2: '0',
      videoNowPage: '1',
      liList: [
        { id: 1, name: '全部' },
        { id: 2, name: '文章' },
        { id: 3, name: '图文' },
        { id: 4, name: '视频' },
      ],
      liList2: [
        { id: 1, name: '推荐' },
        { id: 2, name: '贷款' },
        { id: 3, name: '保险' },
        { id: 4, name: '健康' },
        { id: 5, name: '教育' },
        { id: 6, name: '汽车' },
        { id: 7, name: '财经' },
        { id: 8, name: '生活' },
        { id: 9, name: '互动' },
      ],
      level1: '1',
      level2: '推荐',
      dataList: [],
      dataList1: [],
      id: "",
      code: "",
      ket: 0,
      baseUrl: "https://zf.dtfcloud.com",
      // show: false,//弹出购买框
      bannerList: [],
      pid: '' //经纪人邀请好友自己的id
    }
  },
  mounted() {
    if (location.hostname === "zf.dtfcloud.com") {
      this.baseUrl = "https://zf.dtfcloud.com";
    } else {
      this.baseUrl = "https://jzt.dtfcloud.com";
    }
    if (this.getUrlParams("flag")) {
      this.text = this.baseurl + "platform/#/home?pid=" + this.userid;
    }
    // window.location.href = process.env.VUE_APP_BASE_URL+'#/home';
    // this.getProductType();
    this.checkOpenid();
    this.getBanner();
    // eslint-disable-next-line no-undef
    // if (returnCitySN) {
    //   // eslint-disable-next-line no-undef
    //   setLocal("cip", returnCitySN.cip);
    // }
    if (sessionStorage.getItem("isShowPop") == "1" || localStorage.getItem("buyFlag") == 1) {
      this.show = false;
    } else {
      // 广告弹层暂时关闭
      // this.show = true;
    }
    this.getData()
    this.getArticles()
    this.getTopArticle()
    this.getVideoInfo()
  },
  methods: {
    routerImg(){
      window.location.href='https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzA4ODcwNzExMw==#wechat_redirect '
    },
    leaderboard(){//排行榜
      this.$router.push('/leaderboard')
    },
    getData() {//捷报数据
      let data = {
        type: 'current'
      }
      this.$fetchGet(URLTB.getBroadcast.url, data).then(res => {
        this.newsList = res.data.data
      })
    },
    routerPath(){
      window.location.href='https://dtfcloud.com/loadPath.html'

    },
    checkImg(v) {
      setLocal('img', v.img)
      setLocal('Qimg', v.qrCode)
      setLocal('Simg', v.consultCode)
      setLocal('productId', v.id)
      this.$router.push({ path: '/showBusiness', query: { id: v.id } })
    },
    goinfo() {
      this.$router.push('/information')
    },
    getVideoInfo() {
      let that = this
      that.$fetchPost(URL.getVideoInfo.url, {
        now_page: that.videoNowPage,
        row_num: 10,
        open_id: localStorage.getItem('openid'),
        teb_type: that.level2 === '推荐' ? '' : that.level2
      }).then(res => {
        that.videoInfos = res.list
      })
    },
    getTopArticle() {
      let that = this
      that.$fetchPost(URL.getTopArticle.url, {
        open_id: localStorage.getItem('openid'),
        teb_type: that.level2 === '推荐' ? '' : that.level2
      }).then(res => {
        that.dataList = res.data
      })
    },
    getArticles() {
      let that = this
      // Toast.loading({
      //   message: "加载中...",
      //   duration: 0,
      //   forbidClick: true
      // });
      that.$fetchPost(URL.getHomeArticle.url, {
        now_page: that.pageNum,
        row_num: 20,
        open_id: localStorage.getItem('openid'),
        teb_type: that.level2 === '推荐' ? '' : that.level2,
        file_type: that.level1
      }).then(res => {
        if (res.data) {
          Toast.clear();
          that.dataList1 = res.data.slice(0, 5)
        }

      })
    },
    goToDetails(id, imgUrl) {
      this.$router.push({
        name: "articleDetails",
        query: {
          articleId: id,
          picUrl: imgUrl,
          openId: sessionStorage.getItem("openId"),
          canBack: "y",
          showLongBtn: 'n'
        }
      })
    },

    // 图文
    sceneImg(ele, e) {
      this.$router.push({ path: '/graphicDetails', query: { articleId: ele.artcId } })
    },
    chooseLi(item, i) {
      this.isLink = i
      // this.level1 = item.name
      this.level1 = item.id
      this.getArticles()
    },
    chooseLi2(item, i) {
      this.isLink2 = i
      this.level2 = item.name
      this.getArticles()
    },
    moreArticles() {
      this.$router.push('/moreArticles')
    },

    getUrlParams: function (paramsName) {
      const url = window.location.href; //当前页面的地址
      const reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName === paramsName) {
          return obj[keyName];
        }
      }
    },
    // getProductType() {
    //   this.$fetchGet(URL.getProductType.url).then((res) => {
    //     // this.productList=res.data
    //   });
    // },
    checkInput() {
      this.$router.push({
        path: '/search',
        query: { inputFocus: 1 }
      })
    },
    closePop() {
      setSession("isShowPop", 1);
    },
    // isPay() {
    //   // let cip=returnCitySN['cip']
    //   if (localStorage.getItem("isLogin") != 1) {
    //     this.$router.push({ path: '/login', query: { isLogin: 1 } })
    //     return
    //   }
    //   if (localStorage.getItem("authFlag") == 0) {
    //     Toast('请前往，我的->其他服务，下进行实名认证')
    //     return
    //   }
    //   if (localStorage.getItem("buyFlag") == 1) {
    //     Toast('您已购买，请勿重复购买')
    //     return
    //   }
    //   let data = "https://dtfcloud.com/platform/#/home";
    //   jspay(data);
    // },
    checkDetails(value) {
      this.$router.push({ path: "/productList", query: { value: value } });
    },

    moreList() {
      // this.$router.push('/hotProduct/details')
    },
    checkOpenid() {
      let openid = localStorage.getItem("openid");
      this.$fetchPost(URL.checkOpenid.url + openid).then((res) => {
        if (res.data.code == 20000) {
          this.ket = 1;
          setLocal("isLogin", 1);
          setLocal("phone", res.data.data.phoneNo);
          setLocal("authFlag", res.data.data.authFlag);
          setLocal("buyFlag", res.data.data.buyFlag);
          setLocal("showName", res.data.data.showName);
          setLocal("showPhone", res.data.data.showPhone);
          setSession("user_tel", res.data.data.phoneNo);
          setSession("phoneNumber", res.data.data.phoneNo);
          setSession("phone", res.data.data.phoneNo);
          setLocal("cip", res.data.data.ip);
        }
      });
    },
    getBanner() {
      this.$fetchGet(URL.bannerList.url).then((res) => {
        this.bannerList = res.data.data;
      });
    },
    goToVideo(type, indexOrActId) {
      //跳转到视频页面
      let nowpage = 0
      let index = 0

      if (type === 'inner') {
        this.$router.push({
          name: "video",
          query: {
            articleId: indexOrActId
          }
        })
      } else {
        if (type === 'more') {
          nowpage = 3
          index = 0
        } else if (type === 'third') {
          nowpage = Math.ceil((indexOrActId + 1) / 5)
          index = indexOrActId % 5
        }
        this.$router.push({
          name: "video",
          query: {
            now_page: nowpage,
            teb_type: this.artile_type === '推荐' ? '' : this.artile_type,
            currentIndex: index
          }
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.home-header {
  width: 375px;
  background: #fff;
  margin: auto;
  overflow: hidden;
  .header-search {
    width: 345px;
    height: 35px;
    margin: 9.5px auto 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .svg-icon {
      width: 20px;
      height: 21px;
      position: absolute;
      top: 50%;
      right: 5px;
      transform: translateY(-50%);
    }
    .header-search-img {
      height: 35px;
      position: relative;
    }
    /deep/ .van-badge__wrapper {
      height: 35px;
    }
  }
  .van-cell {
    width: 300px;
    height: 28px;
    margin-left: 6px;
    line-height: 28px;
    padding: 0 0 0 16px;
    border-radius: 33.5px;
    border: 1px solid #fc6e09;
    .svg-icon {
      padding-right: 7.5px;
    }
  }
  .home-swipe {
    width: 345px;
    height: 99px;
    margin: 11px auto 0 auto;
    .swipe-img {
      width: 345px;
      height: 99px;
    }
  }
  .messageBox {
    width: 355px;
    margin: 15px auto auto;
    background: url("./img/bg3.png") no-repeat 100%;
    background-size: 100% 100%;
    font-size: 10px;
    font-weight: 400;
    font-family: Source Han Sans CN;
    color: #333333;
    .van-notice-bar {
      height: 30px;
      padding: 0;
      background: transparent;
    }
    .box-left {
      width: 80px;
      display: flex;
      align-items: center;
      img {
        width: 17px;
        height: 15px;
        padding: 0 10px;
      }
    }
  }
  // 购买vip暂时去掉
  // .home-vip {
  //   width: 345px;
  //   height: 84.5px;
  //   margin: 17.5px auto 0 auto;
  //   img {
  //     width: 100%;
  //   }
  // }
}
.home-product {
  width: 375px;
  height: 243px;
  margin-top: 10px;
  // padding-bottom: 18.5px;
  margin-bottom: 25px;
  background: #fff;
  overflow: hidden;
  .home-pro-title {
    width: 345px;
    margin: 10px auto 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .pro-title-left {
    display: flex;
    align-items: center;
    .svg-icon {
      width: 2px;
      height: 13px;
    }
    span {
      padding-left: 14px;
      font-size: 15px;
      font-weight: Bold;
      font-family: "PingFang SC";
      color: #333333;
    }
  }
  .pro-title-right {
    display: flex;
    align-items: center;
    span {
      display: flex;
      padding-right: 7px;
      font-size: 13px;
      font-weight: Regular;
      font-family: PingFang SC;
      color: #666666;
    }
    .svg-icon {
      width: 4.73px;
      height: 5.4px;
    }
  }
}
.home-article {
  height: auto;
  padding-bottom: 15px;
  .home-article-nav {
    width: 345px;
    margin: 11px auto 0 auto;
    list-style: none;
    ul {
      display: flex;
      font-size: 11px;
      justify-content: space-between;
    }
    .li-style {
      width: 72.5px;
      height: 21.5px;
      line-height: 21.5px;
      text-align: center;
      background: url("./img/bg2.png") no-repeat 100%;
      background-size: 100% 100%;
      font-size: 11px;
      font-family: PingFang SC;
      font-weight: Medium;
      color: #333333;
    }
    .li-check-style {
      background: url("./img/bg1.png") no-repeat 100%;
      background-size: 100% 100%;
      color: #fc6e09;
    }
    .home-nav2 {
      ul {
        width: 345px;
        overflow-x: scroll;
      }
      margin-top: 12.5px;
      .svg-icon {
        width: 13.5px;
        height: 2px;
        display: block;
        margin-left: 5.5px;
        margin-top: 2.5px;
      }
      .li-style2 {
        width: 24.5px;
        font-size: 12px;
        font-family: PingFang SC;
        color: #333333;
        font-weight: Regular;
      }
      .li-check-style2 {
        font-weight: Regular;
        color: #fc6e09;
      }
    }
  }
  .home-data-list {
    width: 345px;
    margin: 16.5px auto 0 auto;
    .home-list-sty:not(:first-child) {
      margin-top: 28px;
    }
    .home-list-sty {
      width: 100%;
      height: 57px;
      display: flex;
      .list-left {
        width: 95px;
        height: 57px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .list-right {
        width: calc(345px - 110px);
        margin-left: 15.5px;
      }
      .list-top-right {
        width: 100%;
        margin: 0;
      }
    }
    .list-r-tit {
      height: 27px;
      line-height: 12.5px;
      display: flex;
      align-items: flex-start;
      span {
        display: block;
        width: 197px;
        height: 26px;
        margin-left: 8px;
        overflow: hidden;
        font-size: 10.5px;
        font-weight: Medium;
        font-family: PingFang SC;
        color: #333333;
      }
      .svg-icon {
        width: 27.5px;
        height: 17px;
      }
    }
    .list-r-foot {
      height: 12.5px;
      line-height: 0;
      display: flex;
      margin-top: 20px;
      span {
        height: 12.5px;
        display: flex;
        font-size: 9px;
        font-weight: Regular;
        font-family: PingFang SC;
        color: #999999;
      }
      .list-top-span {
        color: #ff2e2e;
        margin-right: 5px;
      }
    }
    .list-r-foot span:last-child {
      padding-left: 5px;
    }
    .list-igm-foot {
      display: flex;
      margin-top: 10px;
    }
    .home-imgList-sty {
      width: 100%;
      margin: 9px auto 0 auto;
      .home-isImg {
        display: flex;
        flex-wrap: wrap;
      }
      .home-img-size {
        width: 100%;
      }
      .home-img-size2 {
        width: 110px;
        height: 64px;
        margin-top: 5px;
      }
      .home-img-size2:nth-child(n) {
        margin-right: 7.5px;
      }
      .home-img-size2:nth-child(3n) {
        margin: 0;
      }
      .home-img-size4 {
        width: 40%;
        margin-right: 7.5px;
      }
    }
  }
  .list-top-line {
    width: 345px;
    height: 1px;
    margin: 16.5px auto 0 auto;
    background: #f8f8f8;
  }
}
.van-popup {
  width: 80%;
  background: transparent;
}
.van-popup img {
  width: 100%;
  position: relative;
}
.popup-buttom {
  color: transparent;
  position: absolute;
  bottom: 38px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
